import React from 'react';
import { useTranslation } from '../../localization/useTranslation';

import { Title } from '@patternfly/react-core';

export const Loading = () => {
  const T = useTranslation();
  return <Title headingLevel="h6">{ T.common.authentication.inProgress }</Title>;
};
